import React from 'react'
import { UiCol, UiRowContainer, UiSingleContainer, UiSingleRow } from "../../../components/grid-container/GridContainer"
import UiContentCard from "../../../components/cards/UiContentCard"
import Nike from "../../../../../styles/img/favourites/nike.jpg"
import Loyalty01 from "../../../../../styles/img/loyalty-one.png"
import Loyalty02 from "../../../../../styles/img/loyalty-two.png"
import Loyalty03 from "../../../../../styles/img/loyalty-three.png"
import Loyalty04 from "../../../../../styles/img/loyalty-four.png"
import Loyalty05 from "../../../../../styles/img/loyalty-five.png"


export default function StoresWithAlreadyEarnPoints(props) {
    const shopAgain = () => {
    }

    return (
        <>
            <UiSingleRow>
                <UiCol lg="11">
                    <UiSingleRow className="row-cols-5">
                        <UiCol >
                            <UiContentCard
                                cardImg={Loyalty01}
                                heading="Netflix"
                                shopAgain={shopAgain}
                                body="From its medieval origins to the digital era, learn from its everything, From its past medieval. From medieval."
                            />
                        </UiCol>
                        <UiCol >
                            <UiContentCard
                                cardImg={Loyalty02}
                                heading="Gymshark"
                                shopAgain={shopAgain}
                                body="From its medieval origins to the digital era, learn from its everything, From its past medieval. From medieval."
                            />
                        </UiCol>
                        <UiCol>
                            <UiContentCard
                               cardImg={Loyalty03}
                               heading="Clarks"
                                shopAgain={shopAgain}
                                body="From its medieval origins to the digital era, learn from its everything, From its past medieval. From medieval."
                            />
                        </UiCol>
                        <div className="sb-loyalty-banner">
                            <div className='sb-loyalty-banner__content'>
                                <h4>Loyalty Points Earned:</h4>
                                <h3>13,650 Points</h3>
                                <h5>In February 2023</h5>
                                    <div className='sb-loyalty-banner__button'>
                                        <span>See All Earnings</span>
                                    </div>
                            </div>
                        </div>
                    </UiSingleRow>
                </UiCol>
            </UiSingleRow>
            <UiSingleRow>
                <UiCol lg="11">
                    <UiSingleRow className="row-cols-5">
                        <UiCol>
                            <UiContentCard
                                cardImg={Loyalty04}
                                heading="Beckham Eyewear"
                                shopAgain={shopAgain}
                                body="From its medieval origins to the digital era, learn from its everything, From its past medieval. From medieval."
                            />
                        </UiCol>
                        <UiCol>
                            <UiContentCard
                                cardImg={Loyalty05}
                                heading="MVMT Watches"
                                shopAgain={shopAgain}
                                body="From its medieval origins to the digital era, learn from its everything, From its past medieval. From medieval."
                            />
                        </UiCol>
                        <UiCol >
                            <UiContentCard
                                cardImg={Loyalty01}
                                heading="Netflix"
                                shopAgain={shopAgain}
                                body="From its medieval origins to the digital era, learn from its everything, From its past medieval. From medieval."
                            />
                        </UiCol>
                        <UiCol >
                            <UiContentCard
                                 cardImg={Loyalty02}
                                 heading="Gymshark"
                                shopAgain={shopAgain}
                                body="From its medieval origins to the digital era, learn from its everything, From its past medieval. From medieval."
                            />
                        </UiCol>
                        <UiCol >
                            <UiContentCard
                                 cardImg={Loyalty03}
                                 heading="Gymshark"
                                shopAgain={shopAgain}
                                body="From its medieval origins to the digital era, learn from its everything, From its past medieval. From medieval."
                            />
                        </UiCol>

                    </UiSingleRow>

                </UiCol>
            </UiSingleRow>

        </>
    )
}
